import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-20e221b5"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "user-order-root-page main-scroll-topbar-content"
};
const _hoisted_2 = {
  class: "order-content order-content-all"
};
const _hoisted_3 = {
  key: 0,
  class: "ticket-list-box"
};
const _hoisted_4 = {
  class: "order-id-box"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "left-part"
};
const _hoisted_7 = {
  class: "price-box"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "color-block color-block-1"
}, null, -1));

const _hoisted_9 = {
  class: "price-text"
};
const _hoisted_10 = {
  class: "price-number"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "price-tag"
}, "RMB", -1));

const _hoisted_12 = {
  class: "tickeks-title"
};
const _hoisted_13 = {
  class: "right-part"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "buy-now"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 1
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-tip"
}, "扫描下方二维码完成支付", -1));

const _hoisted_19 = {
  class: "share-img-wrapper"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  class: "logout-wrapper"
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logout-tip-text"
}, "请返回上一支付场景完成支付，或重新下单", -1));

const _hoisted_23 = {
  class: "btn-box"
};
import TopNavigator from "../components/TopNavigator.vue";
import { ref, onMounted, onBeforeMount } from "vue";
import request from "../assets/utils/request";
import { Toast, Dialog } from "vant";
import router from "../router";
import CommonBtn from "../components/CommonBtn.vue";
import { nftShopApi, payTypeEunm, SALTSTR } from "../common.config";
import { getServerTime, initWxJssdk, jsonify, encodeRSA, browserType, date2ISO } from "../assets/utils/common.utils";
import AV from "../assets/utils/av";
import wx from "weixin-js-sdk";
export default {
  __name: 'UserOrders',
  props: {},

  setup(__props) {
    const props = __props;
    const VanDialog = Dialog.Component;
    const tabActive = ref("all");
    const tabMap = [{
      name: "all",
      title: "全部"
    }, {
      name: "pending",
      title: "待支付"
    }, {
      name: "paid",
      title: "待使用"
    }, {
      name: "finished",
      title: "已完成"
    }, {
      name: "closed",
      title: "已关闭"
    }]; // 状态文案

    const statusMap = {
      pending: "待支付",
      paid: "待使用",
      finished: "已完成",
      closed: "已关闭"
    }; // 付款文案

    const payMap = {
      pending: "待付款：",
      paid: "实付款：",
      finished: "实付款：",
      closed: "应付款："
    }; // 操作按钮文案

    const operateBtnMap = {
      pending: "去支付",
      paid: "查看券码",
      finished: "查看详情",
      closed: "查看详情"
    };
    onBeforeMount(() => {
      fetch();
    }); // 获取订单

    const orders = ref(null);

    const fetch = (status = "all") => {
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      request.get(`${nftShopApi}/order/info?req_type=${status}`).then(res => {
        if (res.code == 200) {
          orders.value = res.data;
          orders.value.forEach((item, index) => {
            item.priceStr = Number(item.price) / 100;
            item.totalFeeStr = (item.totalFee / 100).toFixed(2);
            item.statusStr = statusMap[item.status];
            item.payStr = payMap[item.status];
            item.operateBtnStr = operateBtnMap[item.status];
          });
          Toast.clear();
        } else {
          Toast.fail("加载失败");
        }
      }).catch(err => {
        Toast.clear();
        console.error("获取订单：", err);
      });
    }; // 标签改变


    const change = (name, title) => {
      orders.value = null;
      fetch(name);
    }; // 查看详情


    const handleToDetail = orderId => {
      router.push(`/user-order-detail?orderId=${orderId}`);
    }; //支付异常弹窗关闭


    const onClosePayDialog = () => {};

    const showPayErrorDialog = ref(false);

    const closeErrorDialog = () => {
      showPayErrorDialog.value = false;
    }; // 快捷按钮操作


    const handleToOperate = orderInfo => {
      if (orderInfo.status === "pending") {
        var _curUser$authData, _curUser$authData$wei;

        // 直接支付
        const curUser = AV.User.current() && AV.User.current().toJSON();
        const openid = curUser === null || curUser === void 0 ? void 0 : (_curUser$authData = curUser.authData) === null || _curUser$authData === void 0 ? void 0 : (_curUser$authData$wei = _curUser$authData.weixin) === null || _curUser$authData$wei === void 0 ? void 0 : _curUser$authData$wei.openid;
        const orderPayType = orderInfo.payType;
        let payType = payTypeEunm.JSAPI;

        if (browserType.versions.wx) {
          payType = payTypeEunm.JSAPI;
        } else if (browserType.versions.mobile || browserType.versions.ios || browserType.versions.android || browserType.versions.iPhone || browserType.versions.iPad) {
          payType = payTypeEunm.H5;
        } else {
          payType = payTypeEunm.NATIVE;
        } // 支付场景异常


        if (payType != orderPayType) {
          showPayErrorDialog.value = true;
          return;
        } else {
          var _orderInfo$ticketCatI;

          // 发起支付操作
          Toast.loading({
            message: "发起支付...",
            forbidClick: true
          }); // 非标准iso无法识别

          const createdAtFormat = date2ISO(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.createdAt);
          const expiresAtFormat = date2ISO(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.expiresAt);
          const salt = `${orderInfo.totalFee}_${createdAtFormat}_${SALTSTR}`;
          const enTotalFeeKey = encodeRSA(salt);
          const prepayParams = {
            pay_type: payType,
            description: orderInfo === null || orderInfo === void 0 ? void 0 : (_orderInfo$ticketCatI = orderInfo.ticketCatInfo) === null || _orderInfo$ticketCatI === void 0 ? void 0 : _orderInfo$ticketCatI.name,
            order_id: orderInfo.objectId,
            total_fee: orderInfo.totalFee,
            openid: openid,
            time_expire: expiresAtFormat,
            created_at: createdAtFormat,
            total_fee_key: enTotalFeeKey
          };
          request.post(`${nftShopApi}/pay/wechat_pay`, prepayParams).then(wechatPayRes => {
            if (wechatPayRes.code == 200) {
              if (payType == payTypeEunm.JSAPI) {
                // JSAPI - 微信环境使用==================================
                const {
                  appid,
                  timestamp,
                  noncestr,
                  package: wxPackage,
                  signType,
                  paySign,
                  prepay_id
                } = wechatPayRes.data;
                const order = AV.Object.createWithoutData("Order", orderInfo.objectId);
                order.set("prepay_id", prepay_id);
                order.save().then(res => {
                  initWxJssdk(() => {
                    wx.chooseWXPay({
                      timestamp: timestamp,
                      nonceStr: noncestr,
                      // 支付签名随机串，不长于 32 位
                      package: wxPackage,
                      // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                      signType: signType,
                      // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                      paySign: paySign,
                      // 支付签名
                      success: function (res) {
                        // 支付成功后的回调函数,检查支付状态
                        router.replace({
                          path: "/check-pay-status",
                          query: {
                            orderId: orderInfo.objectId
                          }
                        });
                      },
                      fail: err => {
                        Toast.fail("支付失败");
                        router.replace("/user-orders");
                      },
                      cancel: function (err) {
                        // 用户取消支付
                        Toast.fail("取消支付");
                        router.replace("/user-orders");
                      }
                    });
                  });
                }).catch(err => {
                  Toast.fail("发起支付失败！");
                  router.replace("/user-orders");
                  console.error("保存prepay_id: ", err);
                });
              } else if (payType == payTypeEunm.H5) {
                // H5 - 移动端浏览器且非微信浏览器==================================
                const {
                  h5_url,
                  order_id
                } = wechatPayRes === null || wechatPayRes === void 0 ? void 0 : wechatPayRes.data;

                if (h5_url && order_id) {
                  const h5RedirectUri = encodeURIComponent(`${window.location.origin}/check-pay-status?orderId=${order_id}`);
                  window.location.href = `${h5_url}&redirect_url=${h5RedirectUri}`;
                } else {
                  Toast.fail("发起支付失败");
                  router.replace("/user-orders");
                }
              } else {
                // NATIVE - PC端==================================
                const {
                  order_id,
                  qrcode_url
                } = wechatPayRes === null || wechatPayRes === void 0 ? void 0 : wechatPayRes.data;

                if (order_id && qrcode_url) {
                  payQrcode.value = qrcode_url;
                  createdOrderId.value = order_id;
                  handleNativePay();
                } else {
                  router.replace("/user-orders");
                  Toast.fail("支付二维码\n生成失败");
                }
              }
            } else if (wechatPayRes.code != 200 && wechatPayRes.data) {
              // wechatPayRes.code == 1002 订单金额解密失败
              Toast.fail(wechatPayRes.data);
            } else {
              Toast.fail("发起支付失败");
              router.replace("/user-orders");
            }
          }).catch(err => {
            Toast.fail("发起支付错误");
            router.replace("/user-orders");
            console.error("发起支付：", err);
          });
        }
      } else {
        // 去详情页面查看票券、或订单详情
        router.push(`/user-order-detail?orderId=${orderInfo.objectId}`);
      }
    }; // native支付回调处理


    const timer1 = ref(null);
    const showDialog = ref(false);
    const payQrcode = ref("");
    const createdOrderId = ref("");

    const handleNativePay = () => {
      if (!showDialog.value) {
        showDialog.value = true;
      }

      request(`${nftShopApi}/order/info/${createdOrderId.value}`).then(res => {
        const {
          status
        } = res === null || res === void 0 ? void 0 : res.data;

        if (status === "paid") {
          // 支付成功跳转支付广告页
          clearTimeout(timer1.value);
          router.replace({
            path: "/add-grounp-buy",
            query: {
              orderId: createdOrderId.value
            }
          });
        } else {
          timer1.value = setTimeout(() => {
            handleNativePay();
          }, 1500);
        }
      }).catch(err => {
        showDialog.value = false;
        clearTimeout(timer1.value);
        Toast.fail("订单查询错误");
        console.error("获取订单详情：", err);
      });
    }; // 关闭分享弹窗回调


    const onCloseShareDialog = () => {
      clearTimeout(timer1.value);
      payQrcode.value = "";
      createdOrderId.value = "";
      Toast.fail("取消支付");
      router.replace("/user-orders");
    };

    return (_ctx, _cache) => {
      const _component_van_empty = _resolveComponent("van-empty");

      const _component_van_tab = _resolveComponent("van-tab");

      const _component_van_tabs = _resolveComponent("van-tabs");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "我的订单"
      }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_tabs, {
        active: tabActive.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => tabActive.value = $event),
        swipeable: "",
        sticky: "",
        "offset-top": "50px",
        onChange: change
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabMap, tab => {
          return _createVNode(_component_van_tab, {
            title: tab.title,
            name: tab.name,
            key: tab.name
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [orders.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [orders.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 0
            }, _renderList(orders.value, order => {
              var _order$ticketCatInfo, _order$ticketCatInfo2;

              return _openBlock(), _createElementBlock("div", {
                class: "ticket-item",
                key: order.objectId
              }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(order.isRedeem ? "兑换" : "订单") + "编号：" + _toDisplayString(order.objectId), 1), _createElementVNode("span", null, _toDisplayString(tab.name === "all" ? order.statusStr : ""), 1)]), _createElementVNode("div", {
                class: "ticket-info",
                onClick: $event => handleToDetail(order.objectId)
              }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(order === null || order === void 0 ? void 0 : order.priceStr), 1), _hoisted_11])]), _createElementVNode("div", _hoisted_12, _toDisplayString(order === null || order === void 0 ? void 0 : (_order$ticketCatInfo = order.ticketCatInfo) === null || _order$ticketCatInfo === void 0 ? void 0 : _order$ticketCatInfo.name) + "·极客公园创新大会2023", 1)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
                class: "ticket-cover-img",
                src: order === null || order === void 0 ? void 0 : (_order$ticketCatInfo2 = order.ticketCatInfo) === null || _order$ticketCatInfo2 === void 0 ? void 0 : _order$ticketCatInfo2.cover
              }, null, 8, _hoisted_14)])], 8, _hoisted_5), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
                class: "tickeks-tips",
                onClick: $event => handleToDetail(order.objectId)
              }, _toDisplayString(order.isRedeem ? "兑换成功" : order.payStr + "￥" + order.totalFeeStr), 9, _hoisted_16), _createVNode(CommonBtn, {
                text: order.operateBtnStr,
                width: "134px",
                height: "32px",
                params: order,
                onHandleClick: handleToOperate
              }, null, 8, ["text", "params"])])]);
            }), 128)) : (_openBlock(), _createBlock(_component_van_empty, {
              key: 1,
              description: tab.name === 'all' ? '还没有订单，快去购票吧~' : '无数据'
            }, null, 8, ["description"]))])) : (_openBlock(), _createElementBlock("div", _hoisted_17))])]),
            _: 2
          }, 1032, ["title", "name"]);
        }), 64))]),
        _: 1
      }, 8, ["active"]), _createVNode(_unref(VanDialog), {
        class: "share-img-dialog",
        show: showDialog.value,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => showDialog.value = $event),
        onClose: onCloseShareDialog,
        showConfirmButton: false,
        closeOnClickOverlay: true,
        "lazy-render": false
      }, {
        default: _withCtx(() => [_hoisted_18, _createElementVNode("div", _hoisted_19, [payQrcode.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "share-img",
          src: payQrcode.value
        }, null, 8, _hoisted_20)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["show"]), _createVNode(_unref(VanDialog), {
        class: "pay-error-dialog",
        show: showPayErrorDialog.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => showPayErrorDialog.value = $event),
        onClose: onClosePayDialog,
        showConfirmButton: false,
        closeOnClickOverlay: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createVNode(CommonBtn, {
          text: "确认",
          type: "plain",
          width: "120px",
          onHandleClick: closeErrorDialog
        })])])]),
        _: 1
      }, 8, ["show"])])], 64);
    };
  }

};